import { useState } from 'react'
import './OnDemandVideo.css'

function getGoogleDrivePreviewUrl(src) {
  const match = src && src.match(/drive\.google\.com\/file\/d\/([^/]+)/)
  return match ? `https://drive.google.com/file/d/${match[1]}/preview` : null
}

export default function OnDemandVideo({ src, poster, title, caption, className = '' }) {
  const [requested, setRequested] = useState(false)
  const drivePreviewUrl = getGoogleDrivePreviewUrl(src)

  return (
    <div className={`on-demand-video ${className}`}>
      {requested ? (
        drivePreviewUrl ? (
          <iframe
            className="on-demand-video__player"
            src={drivePreviewUrl}
            title={title}
            allow="autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <video
            className="on-demand-video__player"
            src={src}
            poster={poster}
            controls
            playsInline
            preload="none"
            autoPlay
          />
        )
      ) : (
        <button
          className="on-demand-video__preview"
          type="button"
          onClick={() => setRequested(true)}
          aria-label={`Play ${title}`}
        >
          {poster && <img src={poster} alt="" loading="lazy" />}
          <span className="on-demand-video__play" aria-hidden="true">
            <svg viewBox="0 0 64 64" focusable="false">
              <circle cx="32" cy="32" r="30" />
              <path d="M27 20v24l19-12z" />
            </svg>
          </span>
          <span className="on-demand-video__label">Play demo</span>
        </button>
      )}
      {caption && <p className="on-demand-video__caption">{caption}</p>}
    </div>
  )
}
